import { useDailyQuota } from "./useDailyQuota";

export const useValidateMaxFileSize = () => {
    const { ensureUsageDetail } = useDailyQuota();
    const validateMaxFileSize = async (sizes: number[]): Promise<boolean> => {
        const { data, error } = await ensureUsageDetail();
        if (error || !data) return false;
        return sizes.every((size) => {
            return size <= data.fileSizeLimit;
        });
    };
    return { validateMaxFileSize };
};
